/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.sleepdoctor-content-with-popout')

  if (!sections.length) return

  sections.forEach(function (section) {
    const mobileSlider = section.querySelector('.content-with-popout__mobile-slider')
    const mobileTrack = section.querySelector('.content-with-popout__mobile-track')
    const mobileSlides = section.querySelectorAll('.content-with-popout__mobile-slide')
    const desktopTabs = section.querySelectorAll('.content-with-popout__desktop-tabs .content-with-popout__tab--expandable')
    const desktopTabContents = section.querySelectorAll('.content-with-popout__tab-content')

    // Mobile slider functionality
    if (mobileSlides.length) {
      // Mobile slide click handler (expand)
      mobileSlides.forEach(function (slide) {
        if (!slide.classList.contains('content-with-popout__mobile-slide--expandable')) return

        slide.addEventListener('click', function (e) {
          // Don't trigger if clicking on back button
          if (e.target.closest('.content-with-popout__back-btn')) return

          // Expand this slide
          slide.classList.add('active')
          mobileTrack.classList.add('has-active')
          mobileSlider.classList.add('has-active')
        })
      })

      // Back button handlers for mobile
      const mobileBackButtons = section.querySelectorAll('.content-with-popout__mobile-slide .content-with-popout__back-btn')
      mobileBackButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation()
          // Find parent slide and remove active state
          const slide = btn.closest('.content-with-popout__mobile-slide')
          if (slide) {
            slide.classList.remove('active')
          }
          mobileTrack.classList.remove('has-active')
          mobileSlider.classList.remove('has-active')
        })
      })
    }

    // Desktop tab functionality
    let activeDesktopTab = null

    if (desktopTabs.length && desktopTabContents.length) {
      desktopTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const tabIndex = this.getAttribute('data-tab')

          // If clicking same tab, close it
          if (activeDesktopTab === tabIndex) {
            hideDesktopTabContent()
            return
          }

          showDesktopTabContent(tabIndex)
        })
      })
    }

    function showDesktopTabContent (tabIndex) {
      // Hide all tab contents
      desktopTabContents.forEach(function (content) {
        content.classList.remove('active')
      })

      // Show selected content
      const selectedContent = section.querySelector('.content-with-popout__tab-content[data-tab="' + tabIndex + '"]')
      if (selectedContent) {
        selectedContent.classList.add('active')
      }

      // Mark active tab and add has-active to containers
      const desktopTabsContainer = section.querySelector('.content-with-popout__desktop-tabs')
      if (desktopTabsContainer) {
        desktopTabsContainer.classList.add('has-active')
      }

      const outerContainer = section.querySelector('.content-with-popout__outer')
      if (outerContainer) {
        outerContainer.classList.add('has-active')
      }

      desktopTabs.forEach(function (tab) {
        tab.classList.toggle('active', tab.getAttribute('data-tab') === tabIndex)
      })

      activeDesktopTab = tabIndex
    }

    function hideDesktopTabContent () {
      desktopTabContents.forEach(function (content) {
        content.classList.remove('active')
      })

      // Remove has-active from containers
      const desktopTabsContainer = section.querySelector('.content-with-popout__desktop-tabs')
      if (desktopTabsContainer) {
        desktopTabsContainer.classList.remove('has-active')
      }

      const outerContainer = section.querySelector('.content-with-popout__outer')
      if (outerContainer) {
        outerContainer.classList.remove('has-active')
      }

      desktopTabs.forEach(function (tab) {
        tab.classList.remove('active')
      })
      activeDesktopTab = null
    }

    // Desktop back button handlers
    const desktopBackButtons = section.querySelectorAll('.content-with-popout__desktop-back-btn')
    desktopBackButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation()
        hideDesktopTabContent()
      })
    })

    // Handle resize - reset states
    let resizeTimeout
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(function () {
        // Reset mobile state
        mobileSlides.forEach(function (slide) {
          slide.classList.remove('active')
        })
        if (mobileTrack) mobileTrack.classList.remove('has-active')
        if (mobileSlider) mobileSlider.classList.remove('has-active')

        // Reset desktop state
        hideDesktopTabContent()
      }, 250)
    })

    // Handle Add to Cart button
    handleAddToCart(section)
  })

  function handleAddToCart (section) {
    const atcButton = section.querySelector('.content-with-popout__atc-btn')
    if (!atcButton) return

    atcButton.addEventListener('click', function (e) {
      e.preventDefault()
      const variantId = this.dataset.productId
      if (!variantId) return

      // Disable button during request
      this.disabled = true
      const originalText = this.textContent
      this.textContent = 'Adding...'

      // Add to cart via Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then(function () {
          // Trigger cart update event for mini-cart
          document.dispatchEvent(new CustomEvent('cart:updated'))

          // Update button text temporarily
          atcButton.textContent = 'Added!'

          // Open cart drawer if available
          const cartDrawer = document.querySelector('cart-drawer')
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open()
          }

          // Reset button after delay
          setTimeout(function () {
            atcButton.textContent = originalText
            atcButton.disabled = false
          }, 2000)
        })
        .catch(function (error) {
          console.error('Error adding to cart:', error)
          atcButton.textContent = 'Error'
          setTimeout(function () {
            atcButton.textContent = originalText
            atcButton.disabled = false
          }, 2000)
        })
    })
  }
})
